export function isFilterSelected(value: any): boolean {
  if (Array.isArray(value) && value.length === 0) {
    return false;
  }
  const invalidValues = ["null", "all", "All", "Any"];

  return value && !invalidValues.includes(value);
}
